import FileSaver from 'file-saver';
import axios from 'axios';
import apiClient from 'lib/apiClient';
import { APP_CONFIG } from 'constants/config';
import { TYPES, TEMPLATES, queueMsg } from './rabbit.service';

export const getUsers = (query = {}) => {
  return apiClient.get('API/1_0/user.php', {
    params: {
      ...query,
    },
  });
};

export const createUser = (data) => {
  return apiClient.post('API/1_0/user.php', data);
};

export const updateUser = (data) => {
  return apiClient.post('API/1_0/user.php', data);
};

export const deleteUser = (id) =>
  apiClient.delete('API/1_0/user.php', { params: { hash: id } });

export const initVerifyNumber = (user_token, verify_code, device_id) =>
  apiClient.post('API/1_0/postAccountVerifyNumber.php', {
    user_token,
    verify_code,
    device_id,
  });

export const getMe = () =>
  apiClient.get('API/1_0/getMe.php?1=1').then((r) => r[0]);

export const sendResetPassword = (username) =>
  apiClient.post('API/1_0/postResetPassword.php', { username });

export const resetPassword = (password, token) =>
  apiClient.post('API/1_0/postResetPassword.php', {
    user_token: token,
    password,
  });

export const forceResetPassword = (hash) =>
  apiClient.post('API/1_0/postForceResetUserPassword.php', {
    hash,
  });

export const skipOnboarding = async (userhash) => {
  return await apiClient.post('API/1_0/user.php', {
    hash: userhash,
    user_onboarded: '1',
  });
};

export const sendUserInviteEmail = (user, account) => {
  return queueMsg(TYPES.SEND_TEMPLATE_MAIL, {
    hash: TEMPLATES.INVITE_USER[APP_CONFIG.STAGE][account.account_brand],
    account_id: account.account_id,
    user_id: user.user_id,
    account_name: account.account_name,
    user_first_name: user.user_first_name,
    to_email: user.user_username,
  });
};

export const sendRaffleEmail = (user, account, values) => {
  const name = `${values.first_name} ${values.last_name}`;

  return axios.get('https://hooks.zapier.com/hooks/catch/465525/of3lcro/', {
    params: {
      name,
      email: user.user_username,
      account_id: account.account_id,
      address: values.address,
      city: values.city,
      state: values.state,
      zip: values.zip,
      country: values.country,
      tshirt_size: values.size,
      brand: account.account_brand,
    },
  });
};

export const getUserAccounts = (userId) =>
  apiClient.get('API/1_0/userAccount.php', { params: { user_id: userId } });

export const signOut = (userId, accountId) =>
  apiClient.delete('API/1_0/session.php', {
    data: {
      user_id: userId,
      account_id: accountId,
    },
  });

export const addToConnection = (user_id, connection_id) =>
  apiClient.post('API/1_0/userConnection.php', { user_id, connection_id });

export const removeConnection = (hash) =>
  apiClient.delete('API/1_0/userConnection.php', {
    params: { hash },
  });

export const addToGroup = (user_id, group_id, account_id) =>
  apiClient.post('API/1_0/userGroup.php', {
    user_id,
    group_id,
    account_id,
    load_users: 1,
    load_groups: 1,
  });

export const removeFromGroup = (hash) =>
  apiClient.delete('API/1_0/userGroup.php', {
    params: { hash },
  });

export const getGroups = (user_id) =>
  apiClient
    .get('API/1_0/userGroup.php', {
      params: { user_id, load_groups: 1 },
    })
    .then((resp) => resp.map((i) => i.groups[0]));

export const getUserPhoneNumbers = (user_id) =>
  apiClient.get('API/1_0/getPhoneNumbersByUserID.php', { params: { user_id } });

export const downloadCSV = async () => {
  const resp = await apiClient.get('API/1_0/userExportCSV.php?exportCSV=1');
  const blob = new Blob([resp], { type: 'text/csv;charset=utf-8' });
  FileSaver.saveAs(blob, 'users.csv');
};

export const getUserPermissions = (user_id) =>
  apiClient.get('API/1_0/userAccessPermissions.php', {
    params: { user_id },
  });

export const getJobTitles = () =>
  apiClient.get('API/1_0/userJobTitles.php', {
    params: { account_brand: 'tic' },
  });

export const getLoginHistory = (user_id) =>
  apiClient.get('API/1_0/getUserLogins.php', { params: { user_id } });

export const getPusherAuth = (socketId, type) => {
  return apiClient
    .get(`API/1_0/getPusherAuth.php`, {
      params: {
        socket_id: socketId,
        auth_type: type,
      },
    })
    .then((r) => ({
      auth: r.auth,
      user_data: r.channel_data,
    }));
};

export const getUserLogs = async (params) => {
  const { limit, offset, ...rest } = params;
  const [count, data] = await Promise.all([
    apiClient.get('API/1_0/getUserLogs.php', {
      params: { ...rest, count: 1 },
    }),
    apiClient.get('API/1_0/getUserLogs.php', { params }),
  ]);
  return {
    total: +count.total,
    data,
  };
};

export const getUserLogTypes = () =>
  apiClient.get('API/1_0/getUserLogTypes.php');

export const postUserMFAChannel = (action, mfa_channel, data = {}) =>
  apiClient.post('API/1_0/postUserMFAChannel.php', {
    action,
    mfa_channel,
    ...data,
  });
